import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type DeliveryAddress = {
  delivery_address_id?: number; // 배송지 idx
  user_id?: number; // 유저 idx
  recipient_address?: string; // 배송지 주소
  recipient_address_detail?: string; // 배송지 상세주소
  recipient_name?: string; // 수신자 이름
  recipient_phone?: string; // 수신자 연락처
  request?: string; // 요청사항
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] DeliveryAddress
   * --
   */
  getDeliveryAddresses: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_DELIVERY_ADDRESS, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] DeliveryAddress
   * --
   */
  getDeliveryAddress: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_DELIVERY_ADDRESS, {
        delivery_address_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] DeliveryAddress
   * --
   */
  createDeliveryAddress: async (body: DeliveryAddress) => {
    try {
      const res = await $http.post(APIConstant.CREATE_DELIVERY_ADDRESS, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] DeliveryAddress
   * --
   */
  updateDeliveryAddress: async (body: DeliveryAddress) => {
    try {
      const { delivery_address_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_DELIVERY_ADDRESS, {
        delivery_address_id: delivery_address_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] DeliveryAddress
   * --
   */
  deleteDeliveryAddress: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_DELIVERY_ADDRESS, {
        delivery_address_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
